import { render, staticRenderFns } from "./Hold.vue?vue&type=template&id=40be8335&scoped=true&"
import script from "./Hold.vue?vue&type=script&lang=js&"
export * from "./Hold.vue?vue&type=script&lang=js&"
import style0 from "./Hold.vue?vue&type=style&index=0&id=40be8335&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40be8335",
  null
  
)

export default component.exports